import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { formatNumber } from "utils/currencyFormat";

// Popup chọn Tiền mặt / Chuyển khoản trước khi tạo phiếu, mở chồng lên popup nghiệp vụ (vd đóng lãi qua checkbox)
const ChonHinhThucThanhToan = ({
  show,
  soTien,
  giaTriMacDinh,
  onDong,
  onXacNhan,
}) => {
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState("0");

  useEffect(() => {
    if (show) setHinhThucThanhToan(String(giaTriMacDinh || 0));
  }, [show, giaTriMacDinh]);

  // Popup cha nghe Esc trên document để đóng cả màn: chặn ở pha capture của window để Esc chỉ đóng popup này
  useEffect(() => {
    if (!show) return undefined;
    const chanEsc = (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        onDong();
      }
    };
    window.addEventListener("keydown", chanEsc, true);
    return () => window.removeEventListener("keydown", chanEsc, true);
  }, [show, onDong]);

  return (
    <Modal
      show={show}
      onHide={onDong}
      keyboard={false}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ zIndex: 1060 }}
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-thanh-toan-v2.png" />
          </span>
          Hình thức thanh toán
        </h4>
        <button type="button" className="close-popup-new" onClick={onDong}>
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div className="form form-horizontal">
          <div className="form-body">
            <div className="form-group row">
              <label className="col-md-5 label-control">
                <span class="font-nguoi-nhan">Số tiền :</span>
              </label>
              <div
                className="col-md-7 font-nguoi-nhan"
                style={{ textAlign: "left" }}
              >
                {formatNumber(soTien)}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-md-5 label-control color7-bold">
                Hình thức thanh toán <span className="canh-bao-red">*</span>
              </label>
              <div className="col-md-5">
                <select
                  className="form-control input-sm"
                  value={hinhThucThanhToan}
                  onChange={(e) => setHinhThucThanhToan(e.target.value)}
                >
                  <option value="0">Tiền mặt</option>
                  <option value="1">Chuyển khoản</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={onDong}
        >
          <span>
            <i className="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng
        </button>
        <button
          type="button"
          className="btn btn-new-main button-popup-submit"
          onClick={() => onXacNhan(parseInt(hinhThucThanhToan, 10))}
        >
          <span>
            <i className="mdi mdi-check-underline-circle"></i>
          </span>
          &nbsp; Xác nhận
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChonHinhThucThanhToan;
